import { roles } from '../constant/constant';

export class AuthResult {
    authtoken: string = '';
    rememberme: boolean = false;
    userid: string = '';
    name: string = '';
    userrole: any = [];
}

export class JwtPayload {
    user_guid: string;
    email: string;
    role: roles;
    role_id: number;
}
